import React, { useState } from "react";

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import Autorizaciones from "./Autorizaciones";
import FormularioPerfilUsuario from "./FormularioPerfilUsuario";

const BasicElements = () => {
  document.title = "Basic Elements | Siga ERP";

  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Autorizaciones />
          <FormularioPerfilUsuario />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BasicElements;
